import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { EditRounded, VisibilityRounded } from "@mui/icons-material";
import { AdminToggle, DataTableColumn, TagChip } from "../../../components/ui";
import { OralModel } from "../../../models/Oral.model";

type Options = {
    onToggle: (active: OralModel) => void;
    onEdit: (product: OralModel) => void;
    onView: (product: OralModel) => void;
};

/** Colunas da tabela de ativos orais (Nome / Classificação / Status / Ações). */
export function buildOralColumns({ onToggle, onEdit, onView }: Options): DataTableColumn<OralModel>[] {
    return [
        {
            key: "name",
            header: "Nome",
            width: "2fr",
            render: (row) => <Typography sx={{ fontSize: "14px", fontWeight: 600, color: "text.primary" }}>{row.name}</Typography>,
        },
        {
            key: "classifications",
            header: "Classificação",
            width: "2fr",
            render: (row) => (
                <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
                    {row.classifications.map((c, i) => (
                        <TagChip key={i} label={c} />
                    ))}
                </Box>
            ),
        },
        {
            key: "status",
            header: "Status",
            width: "120px",
            render: (row) => <AdminToggle checked={row.enabled !== false} onChange={() => onToggle(row)} />,
        },
        {
            key: "actions",
            header: "Ações",
            width: "120px",
            align: "right",
            render: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5 }}>
                    <Tooltip title="Editar" placement="top">
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(row);
                            }}
                            aria-label="Editar"
                            sx={{ borderRadius: "9px" }}
                        >
                            <EditRounded sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Visualizar" placement="top">
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onView(row);
                            }}
                            aria-label="Visualizar"
                            sx={{ borderRadius: "9px" }}
                        >
                            <VisibilityRounded sx={{ fontSize: 16 }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ];
}
